import { memo } from 'react';

import { TriangleAlertIcon } from '@air/design-icons';

import { NullState } from '~/components/NullState';

export const WorkspaceAgentAssetListUnavailableState = memo(() => (
  <NullState
    description="It may have been removed, or you may not have access."
    icon={TriangleAlertIcon}
    testId="WORKSPACE_AGENT_ASSET_LIST_UNAVAILABLE"
    title="This list is unavailable"
  />
));

WorkspaceAgentAssetListUnavailableState.displayName = 'WorkspaceAgentAssetListUnavailableState';
